import PptxGenJS from 'pptxgenjs';
import { colors, elementSizes } from '@app/services/export/ppt/variables/constants';
import { copyBold } from '@app/services/export/ppt/variables/typography';
import GlobalsStoreModule from '@app/store/modules/GlobalsStoreModule';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import { AbstractPptComponent, IPptComponentPosition } from '@app/services/export/ppt/classes/AbstractPptComponent';

interface IProps {
	links: INumberNavigationItem[];
	currentIndex: number;
	plural?: string;
	singular?: string;
}

export interface INumberNavigationItem {
	numberLabel: number | string;
	slideNumberLink: number;
}

interface INumberNavigationItemWithUnit extends INumberNavigationItem {
	unit?: string;
}

export class NumberNavigation extends AbstractPptComponent {
	protected slide: PptxGenJS.Slide;

	protected props: IProps;

	protected readonly i18n = getStoreModule(GlobalsStoreModule).i18n;

	public constructor(slide: PptxGenJS.Slide, props: IProps, position: IPptComponentPosition) {
		super(position);
		this.slide = slide;
		this.props = props;
	}

	public create(): void {
		let totalX = this.position.x;

		const links: INumberNavigationItemWithUnit[] = this.props.links.map(link => ({
			numberLabel: link.numberLabel === 0.5 ? '1/2' : link.numberLabel,
			slideNumberLink: link.slideNumberLink,
			unit: (parseInt(`${link.numberLabel}`, 10) <= 1 ? this.props.singular : this.props.plural) || ''
		}));

		links.forEach((item, index) => {
			let width = 0.3;
			const isCurrent = index === this.props.currentIndex;
			const text = isCurrent ? `${item.numberLabel} ${item.unit}` : item.numberLabel.toString();
			const gapOffset = 0.02;

			// needs label, make it wider
			if (this.props.plural && isCurrent) {
				width = Math.max(0.8, this.props.plural.length * 0.1);
			}

			this.slide.addText(text, {
				...copyBold,
				lineSpacing: 0,
				shape: 'rect',
				x: totalX,
				y: this.position.y,
				w: width,
				h: elementSizes.paginationHeight,
				color: colors.blue,
				fill: { color: isCurrent ? colors.lightYellow : colors.lightGray },
				align: 'center',
				valign: 'middle',
				hyperlink: { slide: item.slideNumberLink },
				margin: 0
			});

			totalX += width + gapOffset;
		});
	}

	protected getHeight(): number {
		return elementSizes.paginationHeight;
	}
}
